import {Component, OnDestroy, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {PermissionConfigService} from './permission-config.service';
import {BehaviorSubject, combineLatest, of, Subscription, zip} from 'rxjs';
import {PermissionConfigModel} from './permission-config.model';
import {filter, switchMap, take} from 'rxjs/operators';
import {FormControl, FormGroup} from '@angular/forms';
import {AuthorizationService} from '../../../app/authorization/authorization.service';

@Component({
  selector: 'app-gelios-permission-list-field',
  templateUrl: './gelios-permission-list-field.component.html',
})
export class GeliosPermissionListFieldComponent extends GeliosFieldBaseComponent implements OnInit, OnDestroy {
  permissionConfig: BehaviorSubject<PermissionConfigModel | null> = new BehaviorSubject<PermissionConfigModel | null>(null);
  permissionFormGroup: FormGroup | null = null;
  subscriptions: Subscription[] = [];
  permissionFormGroupSubscriptions: Subscription[] = [];
  copyValueSubscription: Subscription | null;
  groupExpanded: {[name: string]: boolean} = {};
  constructor(
    protected translate: TranslateService,
    protected permissionConfigService: PermissionConfigService,
  ) {
    super(translate);
  }

  onValueChange(event) {
    super.onValueChange(event);
  }

  ngOnInit() {
    super.ngOnInit();
    // if (this.reflexiveField.permissionListConfig.mode === 'custom-role') {
    const configObservable =
      this.reflexiveField.permissionListConfig.mode === 'custom-role' ?
        this.reflexiveField.permissionListConfig.calculatedRoleBehaviorSubject.pipe(
          filter(role => !!role),
          switchMap(
            role => this.permissionConfigService.getPermissionConfigForCalculatedRole(role).pipe(take(1))
          ),
        )
        :
        combineLatest(
          this.reflexiveField.permissionListConfig.roleBehaviorSubject,
          this.reflexiveField.permissionListConfig.userCreatorId,
          this.reflexiveField.permissionListConfig.customRoleId,
        ).pipe(
          filter(([role, userCreatorId, customRoleId]) => {
            if (!role) {
              return false;
            }
            if (role === AuthorizationService.ROLE_SUPERUSER || role === AuthorizationService.ROLE_ADMIN) {
              return true;
            }
            return !!userCreatorId;
          }),
          switchMap(
            ([role, userCreatorId, customRoleId]) =>
              this.permissionConfigService.getPermissionConfigForUser(role, userCreatorId, customRoleId).pipe(take(1))
          ),
        );
    this.subscriptions.push(
      configObservable
        .pipe(
          filter(permissionConfig => !!permissionConfig)
        )
        .subscribe(
          permissionConfig => {
            if (this.copyValueSubscription) {
              this.copyValueSubscription.unsubscribe();
            }
            this.permissionConfig.next(permissionConfig);
            this.permissionFormGroupSubscriptions.forEach(s => s.unsubscribe());
            this.permissionFormGroupSubscriptions = [];

            const controls = permissionConfig.conditions.reduce(
              (acc, condition) => ({
                ...acc,
                ...condition.groups.reduce(
                  (acc2, group) => ({
                    ...acc2,
                    ...group.permissions.reduce(
                      (acc3, permissionName) => {
                        if (!(permissionName in this.formGroup.controls[this.fieldName].value)) {
                          this.formGroup.controls[this.fieldName].value[permissionName] =
                            this.reflexiveField.permissionListConfig.defaultCheckboxValue;
                        }
                        const formControl = new FormControl({
                          value: this.formGroup.controls[this.fieldName].value[permissionName],
                          disabled: permissionConfig.config[permissionName].mandatory,
                        });
                        this.permissionFormGroupSubscriptions.push(
                          formControl.valueChanges.subscribe(
                            (value) => {
                              this.dependencyCheck(permissionConfig, permissionName, value, 1, {});
                            }
                          )
                        );
                        return {
                          ...acc3,
                          [permissionName]: formControl,
                        };
                      },
                      {}
                    )
                  }),
                  {}
                )
              }),
              {}
            );
            // console.log(controls);
            this.permissionFormGroup = new FormGroup(controls);

            this.copyValueSubscription = this.permissionFormGroup.valueChanges.subscribe(
              value => {
                this.formGroup.controls[this.fieldName].setValue(value);
                this.onValueChange({fieldName: this.fieldName, value: value});
              }
            );
            console.log(this.permissionFormGroup.controls);
            // const roleConfig = permissionConfig.roles[role];
            // Object.keys(roleConfig).forEach(
            //
            // )
          }
        )
    );
  }

  dependencyCheck(permissionConfig: PermissionConfigModel, permissionName: string, value: boolean, iteration: number, checked: {[n: string]: boolean}) {
    console.log([checked, iteration]);
    if (iteration > 100) {
      return;
    }
    const formGroup = this.permissionFormGroup;
    const controls = formGroup.controls;
    checked[permissionName] = true;
    if (value) {
      const dependencies = permissionConfig.config[permissionName].depends;
      dependencies.forEach(
        dependencyPermissionName => {
          if (!(dependencyPermissionName in checked)) {
            controls[dependencyPermissionName].setValue(true, {emitEvent: false});
            this.dependencyCheck(permissionConfig, dependencyPermissionName, true, iteration + 1, checked);
          }
        }
      );
    } else {
      Object.keys(permissionConfig.config).forEach(
        dependencyPermissionName => {
          if (!(dependencyPermissionName in checked)) {
            if (permissionConfig.config[dependencyPermissionName].depends.includes(permissionName)) {
              controls[dependencyPermissionName].setValue(false, {emitEvent: false});
              this.dependencyCheck(permissionConfig, dependencyPermissionName, false, iteration + 1, checked);
            }
          }
        }
      );
    }
  }

  groupStats(permissions: string[]): string {
    const total = permissions.length;
    const selected = permissions.reduce(
      (acc, perm) => acc + (this.permissionFormGroup.controls[perm].value ? 1 : 0),
      0
    );
    return `${selected}/${total}`;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subscriptions.filter(s => !!s).forEach(s => s.unsubscribe());
    if (this.copyValueSubscription) {
      this.copyValueSubscription.unsubscribe();
    }
  }
}
